import React, { useEffect } from "react";
import { ToastProvider } from "../Hooks/toast";
import { BalanceProvider } from "../Hooks/useBalance";
import { SupportProvider } from "./SupportContext";

const ApplicationProvider: React.FC = ({ children }) => {
  return (
    <ToastProvider>
      <BalanceProvider>
        <SupportProvider>
          {children}
        </SupportProvider>
      </BalanceProvider>
    </ToastProvider>
  );
};

export default ApplicationProvider;
